var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"CandleStick"}},[_c('highcharts',{ref:"chart",staticClass:"stock",staticStyle:{"height":"100%"},attrs:{"id":"candleStick","constructor-type":'stockChart',"options":_vm.stockOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }